'use strict'
const baseTable = require('./base-table')

// this creates a map for code as hexString -> codecName

const nameTable = {}
module.exports = nameTable

for (let encodingName in baseTable) {
  let code = baseTable[encodingName]
  nameTable[code.toString('hex')] = encodingName
}



//////////////////
// WEBPACK FOOTER
// ./~/multicodec/src/name-table.js
// module id = 282
// module chunks = 0